// vue
import { ref, computed, ComputedRef, PropType } from 'vue';

// types
import { Props, Context, IStatusTypes, IColors } from '../types';

// store
import { useGl } from '@store/ts/gl';

// Общие пропсы
export const generalProps = {
    status: {
        type: [String, Number] as PropType<Props['status']>,
        required: true,
    },
    text: {
        type: String as PropType<Props['text']>,
        required: true,
    },
};

export const shared = (props: Readonly<Props>, context: Context) => {
    // store
    const gl = useGl();

    const type = computed(() => {
        const types: IStatusTypes = {
            '0': 'warning',
            '1': 'success',
            '3': 'error',
            '-5': '',
            '-10': '',
        };
        
        return types[String(props.status) as keyof IStatusTypes] || '';
    });

    const colors: ComputedRef<IColors> = computed(() => ({
        warning: 'text-yellow-500',
        success: gl.darkTheme ? 'text-green-500' : 'text-green-700',
        error: 'text-red-500',
        info: 'text-blue-500',
    }));

    const color = computed(() => colors.value[type.value as keyof IColors]);

    return {
        type,
        color,
    };
};